import {Component, OnInit} from '@angular/core';
import {Location} from "@angular/common";

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
    currentPath: string = '';
    activeIndex: number | null = null;
    sections = [
        {
            heading: "When was ARNI University established?",
            content: "<p class='font-semibold text-gray-500 p-4'>Under the Act No. 23 of 2009, ARNI was established by the state government of Himachal Pradesh, and it is approved by the University Grants Commission (UGC) under section 2(f) of the UGC Act, 1956. ARNI offers an online and offline admission process for prospective students.</p>"
        },
        {
            heading: "What is the next process after completing all formalities related to registration?",
            content: "<p class='font-semibold text-gray-500 p-4'>Once all the formalities have been completed, including student verification and documentation, the student needs to wait to get an update from the university to attend classes and ID card.</p>"
        },
        {
            heading: "Is ARNI University approved and recognized by the government?",
            content: "<p class='font-semibold text-gray-500 p-4'>ARNI University is approved and recognized by HP-PERC, AIU, BCI, PCI, I.P.C, I.S.O, NCC, and NSS.</p>"
        },
        {
            heading: "Does ARNI University offer Placement Assistance?",
            content: "<p class='font-semibold text-gray-500 p-4'>Of course, apart from providing a world-class education, ARNI focuses on students’ holistic development and provides proper guidance for internships and interviews. We have a placement cell that takes care of students careers by creating job opportunities.</p>"
        },
        {
            heading: "Does ARNI offer scholarships?",
            content: "<p class='font-semibold text-gray-500 p-4'>Yes, we believe that financial limitations should not bind students' talent and aspiration. We have different types of scholarships to fulfill the unique needs of potential aspirants. We offer upto 100% scholarships and other financial assistance to the students.</p>"
        },
        {
            heading: "What is the withdrawal policy of ARNI University?",
            content: "<p class='font-semibold text-gray-500 p-4'>The refund amount at ARNI University is determined based on when a withdrawal request is submitted about the formally notified last date of admission. Students withdrawing 15 days or more before the last date are eligible for a 100% refund, while those withdrawing less than 15 days before receive 90%. A withdrawal within 15 days after the last date allows for an 80% refund, and within 30 days (but more than 15 days) qualifies for 50%. No refund is provided after 30 days from the last date of admission.</p>"
        },
        {
            heading: "Can I apply online?",
            content: "<p class='font-semibold text-gray-500 p-4'>Yes, through the admission management system, ARNI offers the facility to apply online or offline. To apply online, students need to follow a few simple steps and wait for verification and confirmation from the university’s side.</p>"
        },
        {
            heading: "Is there a hostel or transport facility?",
            content: "<p class='font-semibold text-gray-500 p-4'>Yes, ARNI has an accommodation facility for both boys and girls. The hostel has AC/Non-AC rooms with tasty food made with proper hygiene. Moreover, there are separate hostels for boys and girls as well. A bus facility is also available for the students.</p>"
        },
        {
            heading: "Is there any entrance examination?",
            content: "<p class='font-semibold text-gray-500 p-4'>Yes, those who qualify must take the entrance exam at ARNI University. However, the university may choose to exempt applicants who have passed national-level exams such as JEE, CAT, MAT, CLAT, etc.</p>"
        },
        {
            heading: "If there is a mistake in my ID card, what should I need to do?",
            content: "<p class='font-semibold text-gray-500 p-4'>Write an application and submit it to the department, noting any corrections that need to be made to the card. After four days of the application being submitted, a new ID card will be issued.</p>"
        },
        {
            heading: "What are the eligibility criteria to apply for scholarships?",
            content: "<p class='font-semibold text-gray-500 p-4'>We have different types of scholarships. Visit <a class='text-blue-600 underline' href='https://demoarni.volmint.com/admissions/scholarship'>https://demoarni.volmint.com/admissions/scholarship</a> to learn more about the eligibility.</p>"
        },
    ];

    constructor(private location: Location,) {
        this.currentPath = this.location.path();
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }

}
